const notesCreateFormatter = (data, reviewFormData) => {
  const dataSet = data?.data || data;
  const reviewData = JSON.parse(JSON.stringify(reviewFormData));
  reviewData["id"] = dataSet["id"];
  return reviewData;
};

export default notesCreateFormatter;
